import { VehicleLocation, VehicleLocationFormValues } from "./types";

export const transformVehicleLocation = (res: any): VehicleLocation => ({
  id: res.id ?? null,
  locationType: res.locationType ?? null,
  name: res.name ?? null,
  locationName: res.locationName ?? null,
  officeId: res.officeId ?? null,
  officeName: res.officeName ?? null,
  contactId: res.contactId ?? null,
  contactName: res.contactName ?? null,
  addressLine1: res.addressLine1 ?? null,
  addressCity: res.addressCity ?? null,
  addressPostalCode: res.addressPostalCode ?? null,
  addressCountry: res.addressCountry ?? null,
  note: res.note ?? null,
  driverId: res.driverId ?? null,
  driverName: res.driverName ?? null,
  validFrom: res.validFrom ? new Date(res.validFrom) : null,
  validUntil: res.validUntil ? new Date(res.validUntil) : null,
  isActive: res.isActive ?? false,
  vehicleStatusHistoryId: res.vehicleStatusHistoryId ?? null,
  vehicleStatus: res.vehicleStatus ?? null,
  created: res.created ? new Date(res.created) : null,
  userCreatedName: res.userCreatedName ?? null,
});

/**
 * Šalje se samo ono što vrsta lokacije nosi — backend ionako odbacuje nositelja
 * koji ne odgovara vrsti, pa nema smisla slati zaostale vrijednosti iz forme.
 */
export const transformVehicleLocationOnSave = (
  formValues: VehicleLocationFormValues
): any => ({
  locationType: formValues.locationType,
  name: formValues.name,
  officeId: formValues.officeId,
  contactId: formValues.contactId,
  addressLine1: formValues.addressLine1,
  addressCity: formValues.addressCity,
  addressPostalCode: formValues.addressPostalCode,
  addressCountry: formValues.addressCountry,
  note: formValues.note,
  driverId: formValues.driverId,
  validFrom: formValues.validFrom,
});
